
import dispatch from '../../utils/event';
import { defineComponent, ref, SetupContext, getCurrentInstance, Ref } from 'vue';
import { IInvaliField } from './../../typing/form';

export default defineComponent({
  name: 'TForm',
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Object,
      default: () => {},
    },
  },
  emits: {},
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-form');
    // 将当前组件的上下文通过provide的形式传递给子组件
    const instance = getCurrentInstance();
    // 定义一个规则列表
    const fields: any = [];

    dispatch.on('form.item.add', res => {
      const uid = instance?.uid || 0;
      if (uid && res.parentUid === uid) {
        fields.push(res.value);
      }
    });

    dispatch.on('form.item.remove', res => {
      const uid = instance?.uid || 0;
      if (uid && res.parentUid === uid) {
        const index = fields.indexOf(res.value);
        if (index !== -1) {
          fields.splice(index, 1);
        }
      }
    });

    const validate = (callback = (validArg: boolean, resultsArg: IInvaliField) => {}) => {
      let valid = true;
      let count = 0;
      let results: IInvaliField = {};
      fields.forEach((field: any) => {
        field.validate('', (message: string, invalids: IInvaliField) => {
          if (message) {
            valid = false;
          }
          results = Object.assign({}, results, invalids);
          if (++count === fields.length) {
            callback(valid, results);
          }
        });
      });
    };

    return { prefixCls, validate };
  },
});
